import "./styles.css";

function Button({ onClick, children, className, disable }) {
  const isDisable = disable && "disable";
  const handleOnClick = () => {
    if (onClick && !disable) {
      onClick && onClick();
    }
  };

  return (
    <button
      className={`primary ${className} ${isDisable}`}
      onClick={handleOnClick}
    >
      {children}
    </button>
  );
}

export { Button };
